export default __webpack_public_path__ + "static/media/doughnut-dark.9453e34d.svg";